module.exports = __webpack_public_path__ + "img/whatsapp.4b756d7b.svg";